import { Box, FormLabel, Stack, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { adminSelectStyles } from "../../../components/Models/admin-modal-theme";
import {
  FIXED_GEMINI_FLASH,
  fallbackCatalog,
  findGroupedOption,
  loadGraderModelCatalog,
  rememberGradingModel,
  rememberedGradingModelId,
  resolveGradingModel,
  toGradingModelGroups,
} from "../../../modules/admin-modules/mark-schemes/grader-models";

const selectStyles = {
  ...adminSelectStyles(),
  menuPortal: (base) => ({ ...base, zIndex: 1600 }),
  groupHeading: (base) => ({
    ...base,
    color: "var(--text-muted)",
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
  }),
};

export function useGraderModelSelection(active) {
  const [groups, setGroups] = useState(() => toGradingModelGroups(fallbackCatalog()));
  const [model, setModel] = useState(() => rememberedGradingModelId() || FIXED_GEMINI_FLASH);
  const [isLoadingModels, setIsLoadingModels] = useState(false);

  useEffect(() => {
    if (!active) return undefined;
    let cancelled = false;
    setIsLoadingModels(true);
    loadGraderModelCatalog()
      .then((catalog) => {
        if (cancelled) return;
        const nextGroups = toGradingModelGroups(catalog);
        const nextModel = resolveGradingModel(catalog, nextGroups, rememberedGradingModelId());
        setGroups(nextGroups);
        setModel(nextModel);
        rememberGradingModel(nextModel);
      })
      .finally(() => {
        if (!cancelled) setIsLoadingModels(false);
      });
    return () => {
      cancelled = true;
    };
  }, [active]);

  const onModelChange = (modelId) => {
    rememberGradingModel(modelId);
    setModel(modelId);
  };

  return {
    groups,
    model,
    onModelChange,
    isLoadingModels,
  };
}

export const GraderModelFields = ({ groups, model, onModelChange, isDisabled, isLoading }) => (
  <Stack spacing={1}>
    <Box>
      <FormLabel fontSize="xs" fontWeight="700" mb={1}>
        Choose your model
      </FormLabel>
      <Select
        styles={selectStyles}
        options={groups}
        menuPortalTarget={typeof document !== "undefined" ? document.body : null}
        menuPosition="fixed"
        value={findGroupedOption(groups, model)}
        onChange={(option) => onModelChange(option?.value ?? FIXED_GEMINI_FLASH)}
        placeholder="Select a model"
        isLoading={isLoading}
        isDisabled={isDisabled || isLoading}
        isClearable={false}
      />
    </Box>

  </Stack>
);
